// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1HMuM","notes":"Notes_notes__D7sMf","note":"Notes_note__fVZ44","markdown":"Notes_markdown__kF3yh"};